( function($){

var pageId = 'page-archived-projects',
	page = '#' + pageId;

$(function(){
	$(document).on("ajax:success", ".archived-projects-table .link-project-unarchive",function(e, result){
        if (result.success) {
            $(this).closest('tr').fadeOut(function() {
                $(this).remove();
            });
        } else {
            simple.dialog.message({
                content: "抱歉，激活失败了，请稍后再试"
            });
        }
	})
})

})(jQuery)
